/* eslint-disable global-require */
const Main = r => require.ensure([], () => r(require('./Main')), 'packages-bundle')
const Form = r => require.ensure([], () => r(require('./Form')), 'packages-bundle')

export default [
  {
    name: 'packages.type',
    path: 'package',
    component: Main,
    meta: { requiresAuth: true },
    children: [
      {
        name: 'packages.type.new',
        path: 'create',
        component: Form
      },
      {
        name: 'packages.type.edit',
        path: ':id/edit',
        component: Form
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/packages/type/routes.js